module.exports = __webpack_public_path__ + "static/media/jorge.cf0fde6c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/squadBackgroundImg/jorge.jpg
// module id = 720
// module chunks = 0